import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    chartId: String,
    series: Object,
    activeSeries: String,
    options: Object,
  }

  #observer = null

  connect() {
    if (this.#chart) {
      this.#applyOptions()
    } else {
      this.#observeChart()
    }
  }

  disconnect() {
    this.#observer?.disconnect()
  }

  selectSeries(event) {
    const key = event.currentTarget.dataset.chartSeries
    if (!key || key === this.activeSeriesValue) return

    if (!this.#chart) return

    this.activeSeriesValue = key
    this.#chart.updateData(this.seriesValue[key] || {})
    this.#highlightCard(event.currentTarget)
    this.#updateMetricParam(event.currentTarget)
  }

  get #chart() {
    return Chartkick.charts[this.chartIdValue]
  }

  #applyOptions() {
    this.#chart.setOptions(this.optionsValue)
    this.#chart.redraw()
  }

  #observeChart() {
    this.#observer = new MutationObserver(() => {
      if (!this.#chart) return

      this.#observer.disconnect()
      this.#applyOptions()
    })
    this.#observer.observe(this.element, { childList: true, subtree: true })
  }

  #highlightCard(activeCard) {
    this.element.querySelectorAll("[data-chart-series]").forEach((card) => {
      card.classList.toggle("ring-2", card === activeCard)
      card.classList.toggle("ring-accent-purple", card === activeCard)
    })
  }

  #updateMetricParam(card) {
    const metric = card.dataset.chartMetric
    if (!metric) return

    const url = new URL(window.location)
    url.searchParams.set("metric", metric)
    history.replaceState(history.state, "", url.toString())
    this.#syncNavigationLinks(metric)
  }

  #syncNavigationLinks(metric) {
    this.element.querySelectorAll("a[href*='month=']").forEach((link) => {
      const linkUrl = new URL(link.href)
      linkUrl.searchParams.set("metric", metric)
      link.href = linkUrl.toString()
    })
  }
}
